<app-data-table mainTitle="Localidade Grupo x Município"
                singleTitle="Localidade Grupo x Município"
                routerPath="/localidade-grupo-municipio"
                entityPath="/localidadegrupomunicipio"
                [entity]="localidadeGrupoMunicipio"
                [entityFilter]="entityFilter"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table>
